// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"9003bf74","644":"084e6773"}[chunkId] + ".chunk.js";
};